module.exports = __webpack_public_path__ + "static-portal/img/51-1.d3dffd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yingyong/51-1.jpg
// module id = +oUL
// module chunks = 4